import { render, staticRenderFns } from "./TabsDashboardAuctions.vue?vue&type=template&id=41d90805&"
import script from "./TabsDashboardAuctions.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardAuctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports